
import { Environment } from './Environment';
import { FetchProxy } from 'intraactive-sdk-helper';
import { sdkContainerInstance } from '../global/Container';
import { IEnvironment } from '../interfaces/IEnvironment';
import { Helper } from '../Helper';
import { IContentOrganizerSharepointSite } from '../interfaces/IContentOrganizerSharepointSite';

export interface ContentOrganizerAIResponse {
  chatReply: string;
  searchKeyWords: string[];
  pageContents: {
    path: string;
    textContent: string;
    title?: string;
    isIncludedInKnowledgebase: boolean;
  }[];
  usage: {
    completionTokens: number;
    promptTokens: number;
    totalTokens: number;
    calculatedTokens: number;
  };
}

export default class ContentOrganizerAIService {
  public static getAIResponse(environment: IEnvironment, tenant: string, contentLanguage: string, sites: string[], query: string): Promise<ContentOrganizerAIResponse> {
    return new Promise((resolve, reject) => {
      if (environment && tenant && sites && query) {
        const apiUrl = `${Environment.getEnvironmentContentOrganizerAIAPI(environment)}/${tenant.replace(".sharepoint.com", "")}/${contentLanguage}/suggest?ContentRequest=${query}&SiteNames=${sites.join("&SiteNames=")}`;
        new FetchProxy(apiUrl, {
          method: "GET",
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: "same-origin"
        }).withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              throw response;
            } else {
              return response.json();
            }
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      } else {
        reject();
      }
    });
  }

  public static getSites(tenant: string, token: string, environment: IEnvironment, searchQuery: string, take?: number, skip?: number): Promise<{ searchQuery: string, totalItems: number, items: IContentOrganizerSharepointSite[] }> {
    const localStorageSearchId = "ContentOrganizerAIService_SearchQuery";
    Helper.setLocalStorage(localStorageSearchId, searchQuery);
    return new Promise<any>((resolve: (sites: any) => void, reject: (error: any) => void): void => {
      let apiUrl = `${Environment.getEnvironmentContentOrganizerAIAPI(environment)}/${tenant.replace(".sharepoint.com", "")}/sites?`;

      if (searchQuery) {
        apiUrl += `&searchQuery=${searchQuery}`;
      }
      if (take !== undefined) {
        apiUrl += `&take=${take}`;
      }
      if (skip !== undefined) {
        apiUrl += `&skip=${skip}`;
      }
      new FetchProxy(apiUrl, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'AuthToken': token
        },
        credentials: "same-origin"
      }).withContainer(sdkContainerInstance)
        .fetch()
        .then((response) => {
          if (!response.ok) {
            reject(response);
            return;
          }
          return response.json().then((result) => {
            if (result.searchQuery === localStorage.getItem(localStorageSearchId) || result.searchQuery === null && localStorage.getItem(localStorageSearchId) === "") {
              resolve(result);
            }
          });
        }).catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
}